import * as React from "react";

function SvgInsider(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 281.1 314.2"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M730.2-225.2h-766v766h766v-766z" fill="#fff" />
      <path d="M155.8 310.2c-8.1 0-16.2-.6-24.4-1.9-41-6.4-77.1-28.4-101.6-61.8C5.4 213-4.5 172 1.9 131.1c6.4-40.9 28.4-76.9 62-101.4 69.3-50.4 166.7-35.2 217.2 33.9l-14.7 10.7C221.8 13.3 135.7-.2 74.5 44.4 44.9 66 25.4 97.8 19.8 133.9s3.1 72.4 24.7 101.9c21.6 29.6 53.5 49 89.7 54.6 36.2 5.7 72.5-3.1 102.2-24.7l10.7 14.6c-26.9 19.7-58.6 29.9-91.3 29.9z" />
      <path d="M210 251.4h68.1l-31.8 62.8-36.3-62.8zM89.1 71.9H118v158.4H89.1V71.9zM139.4 116.5h27.3v13.2c0 4.2-.4 7.8-.4 7.8h.4c4.9-9.6 17.4-23.7 40.5-23.7 25.3 0 39.6 13.2 39.6 43.3v73.2h-28.2V163c0-13.8-3.6-23.2-18.1-23.2-15.2 0-26.4 9.6-30.6 23.2-1.6 4.7-2 9.8-2 15.2v52.2h-28.4V116.5z" />
    </svg>
  );
}

export default React.forwardRef(SvgInsider);
